import {
  GET_COUNTRIES_DATA,
  RESET_AUTH_STATE,
  SET_CURRENT_USER,
  SET_SIGNUP_DATA,
  SET_STATES_OF_COUNTRY,
  SET_USER_FRM_API,
  SWITCH_ACCOUNT_TYPE,
} from "../types";

const initialState = {
  user: {},
  states: [],
  countries: [],
  signupDetails: {},
  isDemoAccount: false,
  isAuthenticated: false,
};

const user = (state = initialState, action) => {
  switch (action.type) {
    case SWITCH_ACCOUNT_TYPE:
      return {
        ...state,
        isDemoAccount: action.payload,
      };
    case SET_CURRENT_USER:
      return {
        ...state,
        isAuthenticated: action.payload,
      };
    case SET_USER_FRM_API:
      return {
        ...state,
        user: action.payload,
      };
    case SET_SIGNUP_DATA:
      return {
        ...state,
        signupDetails: action.payload,
      };
    case GET_COUNTRIES_DATA:
      return {
        ...state,
        countries: action.payload,
      };
    case SET_STATES_OF_COUNTRY:
      return {
        ...state,
        states: action.payload,
      };
    case RESET_AUTH_STATE:
      return initialState;
    default:
      return state;
  }
};

export default user;
